module.exports = __webpack_public_path__ + "fonts/EspumaPro-BookItalic.c00df56.woff";


//////////////////
// WEBPACK FOOTER
// ./static/font/Espuma/EspumaPro-BookItalic.woff
// module id = ./static/font/Espuma/EspumaPro-BookItalic.woff
// module chunks = 5